module.exports = __webpack_public_path__ + "static/img/github.b9c9839.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/external-profiles/github.jpg
// module id = zjO+
// module chunks = 7